import { inject, Injectable } from '@angular/core';
import { CustomHttpClient } from '../core/httpClient/http-client';
import { HeaterPendingAuditResponse } from '@app/models/heaters';

@Injectable({
  providedIn: 'root',
})
export class Heaters {
  http = inject(CustomHttpClient);

  getHeatersInventory(page: number = 1, limit: number = 10) {
    const URLEndpoint = `/inventories/paginated?status=PENDING_AUDIT&page=${page}&limit=${limit}`;
    return this.http.get<HeaterPendingAuditResponse>(URLEndpoint);
  }

  getHeatersInventoryFiltered(
    supplier: string,
    branch: string,
    start: string,
    end: string,
    serial: string,
    page: number = 1,
    limit: number = 10,
  ) {
    const URLEndpoint = `/inventories/paginated?status=PENDING_AUDIT&page=${page}&limit=${limit}&supplier=${supplier}&branch=${branch}&purchaseDateFrom=${start}&purchaseDateTo=${end}&serial=${serial}`;
    return this.http.get<HeaterPendingAuditResponse>(URLEndpoint);
  }

  updateHeaterStatus(
    serial: string[],
    status: 'ACTIVE_IN_PROGRESS' | 'REJECTED',
    comments: string | null = null,
  ) {
    const URLEndpoint = `/inventories/bulk-update-status`;
    const payload = {
      status,
      inventoryIds: serial,
      comments,
    };
    return this.http.patch(URLEndpoint, payload);
  }
}
